import { useBackToTop } from "@/hooks/usePageNav";

export default function BackToTop() {
  const { visible, scrollToTop } = useBackToTop();

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </button>
  );
}